import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export const imageCarousel = () => {
  // find all .is-style-image-carousel
  const imageCarousels = document.querySelectorAll('.is-style-image-carousel');

  // if there are no .is-style-image-carousel, return
  if (!imageCarousels.length) {
    return;
  }

  // add splide classes to each .is-style-image-carousel
  imageCarousels.forEach((imageCarousel) => {
    imageCarousel.classList.add('splide');
    // add splide track and splide list divs

    const track = document.createElement('div');
    track.classList.add('splide__track');
    const list = document.createElement('div');
    list.classList.add('splide__list');

    track.appendChild(list);

    // add splide images to splide list
    const images = imageCarousel.querySelectorAll('.wp-block-image');
    images.forEach((image) => {
      const slide = document.createElement('li');
      slide.classList.add('splide__slide');
      // change image tag to li
      slide.appendChild(image);
      list.appendChild(slide);
    });

    imageCarousel.appendChild(track);

    // init splide
    const splide = new Splide(imageCarousel, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      // perPage: 3,
      fixedWidth: true,
      autoScroll: {
        speed: 0.25,
      },
      arrows: false,
      pagination: false,
    });

    splide.mount({ AutoScroll });
  });
};
